import React from "react";
import * as Yup from "yup";
import { AiOutlineClose } from "react-icons/ai";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import "../onboarding/onboarding.css";
import { resetPassword } from "../../actions/auth.action";
import ErrorInputComponent from "../../components/ErrorInputComponent";
import DocButtomButton from "../../components/DocButtomButton";
import { Loading } from "../../utils/helpers/constants";

export default function ResetPassword() {
  const history = useHistory();
  const dispatch = useDispatch();

  const {
    auth: { resetPasswordLoading },
  } = useSelector(({ authReducer }) => ({
    auth: authReducer,
  }));

  const validationSchema = Yup.object({
    otp: Yup.string().required("OTP is required"),
    password: Yup.string().required("Password is required"),
  });
  const { handleSubmit, handleChange, values, errors } = useFormik({
    initialValues: {
      password: "",
      otp: "",
    },
    validationSchema,
    onSubmit(values) {
      const navigateLink = () => history.push("/login");
      dispatch(resetPassword(values.otp, values.password, navigateLink));
    },
  });

  const buttonLoadState = resetPasswordLoading === Loading.FETCHING;

  return (
    <div className="flex flex-column justify-center">
      <div className="App-height p-5 md:w-1/3 w-screen">
        <div>
          <AiOutlineClose
            size={25}
            className="mt-5"
            onClick={() => history.goBack()}
          />
          <h1 className="a_acc_header mt-5">Reset password</h1>
          <p className="a_acc_header_text">
            Enter the sent to your email to create new password.
          </p>
        </div>
        <form className="mt-10" onSubmit={handleSubmit}>
          <input
            className="appearance-none border border-gray-400 rounded w-full pt-4 pb-4 py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-green-800"
            id="inline-full-name"
            type="text"
            name="otp"
            onChange={handleChange}
            placeholder="OTP"
          />
          <ErrorInputComponent error={errors.otp} />
          <input
            className="mt-5 appearance-none border border-gray-400 rounded w-full pt-4 pb-4 py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-green-800"
            id="inline-full-name"
            type="password"
            name="password"
            onChange={handleChange}
            placeholder="Password"
          />
          <ErrorInputComponent error={errors.password} />
        </form>
        <DocButtomButton
          loading={buttonLoadState}
          name={"Submit"}
          func={() => handleSubmit()}
        />
      </div>
    </div>
  );
}
